<template src="../templates/login.html"></template>

<script>
import jQuery from 'jquery';
import entityStore from '@/store/entityStore';
import userApi from '../api/userApi';
import userAuthStore from '../store/userAuthStore';

export default {
  data() {
    return {
      username: null,
      password: null,
      usernameInvalid: false,
      passwordInvalid: false,
      combinationInvalid: false,
      connectionError: false,
      authSuccess: false,
      userAuth: userAuthStore.state,
      entity: entityStore.state,
    };
  },
  created() {
    jQuery('body').addClass(this.entity.name);
    if (this.entity.bgImgClass !== '') {
      jQuery('body').addClass(this.entity.bgImgClass);
    }
  },
  destroyed() {
    if (this.entity.bgImgClass !== '') {
      jQuery('body').removeClass(this.entity.bgImgClass);
    }
  },
  computed: {
    error() {
      return (this.usernameInvalid ||
        this.passwordInvalid ||
        this.combinationInvalid ||
        this.connectionError ||
        this.userAuth.tokenExpired);
    },
  },
  methods: {
    submitUser() {
      // reset errors
      this.combinationInvalid = false;
      this.connectionError = false;
      this.connectionError = false;
      this.userAuth.tokenExpired = false;

      // check values
      this.usernameInvalid = !this.username;
      this.passwordInvalid = !this.password;

      // if there's no error -> authenticate user
      if (!this.error) {
        // make a call to server
        userApi.authUser(this.username, this.password, (data, connectionError) => {
          // check if there's a connection error
          this.connectionError = connectionError;
          // if there's no connection error -> set the values
          if (!this.connectionError) {
            this.combinationInvalid = !data.validCombi;
            // check if authentication was successful
            if (data.success) {
              userAuthStore.logIn(data.token);

              this.$router.push('/my');
            }
          }
        });
      }
    },
  },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// login.vue?c895f23a